export default {
  methods: {
    toggleContent() {
      this.$el.classList.add('clicked')
      this.$el.children[0].classList.toggle('not-collapsed')
      this.$el.children[1].classList.toggle('hidden')
      document.querySelectorAll('.accordion .collapse').forEach(el => {
        if (el.parentElement.classList.contains('clicked')) return
        if (!el.classList.contains('hidden')) {
          el.classList.add('hidden')
        }
      });
      document.querySelectorAll('.accordion .not-collapsed').forEach(el => {
        if (el.parentElement.classList.contains('clicked')) return
        if (el !== this.$el.children[0]) {
          el.classList.remove('not-collapsed')
        }
      });
      this.$el.classList.remove('clicked');
      // window.dispatchEvent(new Event('resize'))
    }
  }
}